import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '*', redirect: '/'
  },
  {
    path: '/', component: resolve => require(['@/view/pageView'], resolve),
      children: [{
        path: '/', redirect: '/home'},
        {
          path: '/home', name: 'home', component: resolve => require(['@/view/home'], resolve), meta: {
            title: '首页-广州华软科技创新有限公司'
          }
        },
        {
          path: '/software', name: 'software', component: resolve => require(['@/view/software'], resolve), meta: {
            title: '软件产品-广州华软科技创新有限公司'
          }
        },
        {
          path: '/online', name: 'online', component: resolve => require(['@/view/online'], resolve), meta: {
            title: '案例展示-广州华软科技创新有限公司'
          }
        },
        {
          path: '/news', name: 'news', component: resolve => require(['@/view/news'], resolve), meta: {
            title: '新闻动态-广州华软科技创新有限公司'
          }
        },
        {
          path: '/jobChance', name: 'jobChance', component: resolve => require(['@/view/jobChance'], resolve), meta: {
            title: '工作机会-广州华软科技创新有限公司'
          }
        },
        {
          path: '/contact', name: 'contact', component: resolve => require(['@/view/contact'], resolve), meta: {
            title: '联系我们-广州华软科技创新有限公司'
          }
        },
        {
          path: '/serviceDetail',
          name: 'serviceDetail',
          component: resolve => require(['@/view/serviceDetail'], resolve),
          meta: {
            title: '相关服务-广州华软科技创新有限公司'
          }
      }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js